<template>
    <div class="flex flex-col lg:flex-row lg:flex-wrap lg:-mx-5 justify-center mb-12">
        <div v-for="blogpost in items" :key="blogpost.id" class="lg:px-5 w-full sm:w-3/4 md:w-1/2 lg:w-1/3 sm:mx-auto lg:mx-0 mb-8 lg:mb-10">
            <a :href="blogpost.url">
                <div class="w-full h-48 sm:h-64 lg:h-48 mb-5 bg-cover bg-center shadow rounded"
                    :style="backgroundImage(blogpost.hero_image)">
                </div>
            </a>

            <p class="text-orange-500 font-medium mb-1 uppercase">
                <span v-for="tag in blogpost.tags" :key="tag.id">{{ tag.title }}</span>
            </p>

            <a :href="blogpost.url">
                <h4 class="text-lg font-medium" v-text="truncate(blogpost.title, 72, '...')"></h4>
            </a>

            <small class="block mt-2 text-gray-600 text-xs">{{ blogpost.datestring || dateFormat(blogpost.date) }}</small>

            <small class="block mt-2 text-grey-dark text-gray-900 text-xs">
                by {{ blogpost.author_name }}
            </small>
        </div>

        <div id="waypoint" v-waypoint="{ active: currentWaypointStatus, callback: onWaypoint, options: intersectionOptions }"></div>
    </div>

</template>

<script>

import infiniteScroll from '../mixins/infinite-scroll';

export default {

    mixins: [infiniteScroll],

    data: () => ({
        entryType: 'blog',
    }),

    methods: {
        backgroundImage (image) {
            return image ? 'backgroundImage: url(' + image.url + ')' : '';
        },

        dateFormat (date) {
            return new Date(date).toDateString();
        }
    }

}
</script>
